import { ProductDto } from './../product/product.dto';

export class ProductListResponseDto {
  last: boolean;
  sort: string;
  first: boolean;
  numberOfElements: number;
  totalPages: number;
  totalElements: number;
  size: number;
  content: ProductDto[];
  number: number;

  constructor(d?: ProductListResponseDto) {
    if (!d) {
      return;
    }

    this.last = d.last;
    this.sort = d.sort;
    this.first = d.first;
    this.numberOfElements = d.numberOfElements;
    this.totalPages = d.totalPages;
    this.totalElements = d.totalElements;
    this.size = d.size;
    this.content = d.content;
    this.number = d.number;
  }
}
